import { Form } from "../form-builder/form.model";
import { FormTemplatePropertyInfo } from "./form-template-property-info";

export class FormTemplateProperties {
    public siteFormTemplates: Form[] = [];
    public selectedFormTemplate: Form = null;
    public availableProperties: FormTemplatePropertyInfo[];
    public selectedPropertyNames: string[] = [];
}
